const CandidateHandicapCase = {
  Unknown: "UNKNOWN",
  Normal: "NORMAL",
  IndustrialAccident: "INDUSTRIAL_ACCIDENT",
  VeteransDisability: "VETERANS_DISABILITY",
  Etc: "ETC"
};

export { CandidateHandicapCase };
//# sourceMappingURL=candidate-handicap-case.mjs.map
